import { render, staticRenderFns } from "./OtherConsiderations.vue?vue&type=template&id=32b97212&"
import script from "./OtherConsiderations.vue?vue&type=script&lang=js&"
export * from "./OtherConsiderations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports